export default "__VITE_ASSET__fe66d97d__"